var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col col-12" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: { readonly: "" },
          domProps: { value: _vm.valueMutable }
        })
      ]),
      _c("div", { staticClass: "col-md-2 mt-1" }, [
        _c("div", { staticClass: "btn-group" }, [
          _vm.hasPermisionSave
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip",
                      value: "Abrir editor",
                      expression: "'Abrir editor'"
                    }
                  ],
                  staticClass: "btn btn-outline-secondary",
                  on: { click: _vm.openEditor }
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("edit")
                  ])
                ]
              )
            : _vm._e()
        ])
      ]),
      _c(
        "b-modal",
        {
          ref: "modaleditar",
          attrs: {
            id: "modaleditar",
            title: "Editor online",
            size: "xl",
            "hide-footer": ""
          }
        },
        [
          _vm.loadContent
            ? _c("b-spinner", { attrs: { variant: "primary", size: "18" } })
            : _vm._e(),
          !_vm.loadContent
            ? _c("b-card-text", [
                _c("div", { staticClass: "preview" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-12" },
                      [
                        _c("CodeEditor", {
                          on: { input: _vm.input },
                          model: {
                            value: _vm.valueMutable,
                            callback: function($$v) {
                              _vm.valueMutable = $$v
                            },
                            expression: "valueMutable"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm.progress.enabled
            ? _c("vs-progress", {
                attrs: {
                  percent: _vm.progress.percent,
                  indeterminate: _vm.progress.indeterminate,
                  color: _vm.color
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }